import { environment } from '../environments/environment';

export class AppConstants {
	public static LOGIN_PAGE_URL = environment.loginPage;
	public static SUPPLIERDB_BASE_URL = environment.supplierDBUrl;
	public static FILE_SERVICE_BASE_URL = environment.fileServerUrl;

	/*** File Service ***/
	/* Endpoints */
	public static FILE_SERVER = AppConstants.FILE_SERVICE_BASE_URL + '/publicFile';
	public static CARRIERDB_LOGO = AppConstants.FILE_SERVER + '/cdbLogo';
	public static CARRIERDB_DEFAULT_LOGO_SOURCE = 'assets/img/carrierLogo/carrier.png';
	public static OCCON_LOGO_SOURCE = 'assets/img/logos/OCCON_icon.png';

	/*** Supplier DB Service ***/
	/* General Supplier Info */
	public static SDB_SUPPLIER = AppConstants.SUPPLIERDB_BASE_URL + '/supplier';
	public static SDB_SUPPLIER_REGISTER = AppConstants.SDB_SUPPLIER + '/register';
	public static SDB_SUPPLIER_GET_DATA_BY_TOKEN = AppConstants.SDB_SUPPLIER + "/stagedData";

	public static SDB_SUPPLIER_LOCAL_STORAGE_CONTACT = 'occon-supplierData-contactInfo';
	public static SDB_SUPPLIER_LOCAL_STORAGE_SELECTION = 'occon-supplierData-selectionData';
	public static SDB_SUPPLIER_LOCAL_STORAGE_LOGO = 'occon-supplierData-logo';
	public static SDB_SUPPLIER_LOCAL_STORAGE_ACCESS_TOKEN = 'occon-supplierData-personal-access-token';
	public static SDB_SUPPLIER_LOCAL_STORAGE_JUST_REGISTERED = 'occon-supplierData-just-registered';

	/* Maintenance Mode */
	public static SDB_MAINTENANCE_MODE = AppConstants.SUPPLIERDB_BASE_URL + "/maintenanceMode";

	/* L10N */
	public static L10N_LOCALE_STORAGE_KEY = 'occon-supplierData-locale';

	/* REGEX PATTERNS */
	public static WEBSITE_VALIDATION_REGEX = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9\-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?(\/[^\s]*)?$/;
	public static PHONE_NUMBER_WEBSITE_VALIDATION_REGEX = /^\+?[0-9\s\-()]{7,20}$/;
	public static POSTAL_CODE_VALIDATION_REGEX = /^[A-Za-z0-9\s\-]{3,10}$/;
	public static NUMBER_REGEX = /^[0-9]+$/;
}
